export default function QuoteFilters({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  onSearch,
  onClear,
  searchCode,
  setSearchCode,
  onSearchByCode,
  onClearCode,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString("es-SV", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="invoice-filters">
      <div className="filters-row">
        <div className="form-group">
          <label className="form-label">📅 Fecha Inicio</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">📅 Fecha Fin</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="filters-actions">
          <button className="btn btn-primary" onClick={onSearch}>
            🔍 Buscar
          </button>
          <button className="btn btn-secondary" onClick={onClear}>
            🔄 Limpiar
          </button>
        </div>
      </div>

      <div className="filters-row" style={{ marginTop: "12px" }}>
        <div className="form-group" style={{ flex: 1 }}>
          <label className="form-label">🔎 Buscar por Cliente o N° de Cotización</label>
          <input
            type="text"
            className="form-control"
            placeholder="Ej: Ferretería El Martillo"
            value={searchCode}
            onChange={(e) => setSearchCode(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onSearchByCode()}
          />
        </div>
        <div className="filters-actions" style={{ alignSelf: "flex-end" }}>
          <button className="btn btn-primary" onClick={onSearchByCode}>
            🔍 Buscar
          </button>
          <button className="btn btn-secondary" onClick={onClearCode}>
            🔄 Limpiar
          </button>
        </div>
      </div>

      {fromDate && toDate && (
        <div className="alert alert-info">
          <span>
            📊 Buscando cotizaciones desde <strong>{formatDate(fromDate)}</strong> hasta{" "}
            <strong>{formatDate(toDate)}</strong>
          </span>
        </div>
      )}
    </div>
  );
}